import {Resource} from 'simpli-web-sdk'

export class NoneResource extends Resource {
  constructor(id: number, tag: string) {
    super()
    this.$tag = tag
    this.$id = id
  }

  $id: number
}
